/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What the change is about.
 */
export type ClientEventDtoSubject = typeof ClientEventDtoSubject[keyof typeof ClientEventDtoSubject];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientEventDtoSubject = {
  MEMBERSHIP: 'MEMBERSHIP',
  CLIENT: 'CLIENT',
  DRIVER_GRADE_LINK: 'DRIVER_GRADE_LINK',
  VEHICLE_DISCOUNT: 'VEHICLE_DISCOUNT',
} as const;
